import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { CommonService } from 'src/app/services/common/common.service'
import { AreYouSureModalComponent } from '../modals/are-you-sure-modal/are-you-sure-modal.component'

@Component({
  selector: 'app-sub-menu',
  imports: [],
  templateUrl: './sub-menu.component.html',
  styleUrl: './sub-menu.component.scss',
  standalone: false,
})
export class SubMenuComponent implements OnInit {
  @Input() clientId: string
  @Input() totalReviews: number
  @Input() flipHasAccess: boolean = true
  @Input() reddiHasAccess: boolean = true
  @Input() slatHasAccess: boolean = true
  // Defaults to false (fail closed), unlike the tool flags above — Service Plan is a
  // TSC-only, server-enforced feature flag (ARCH1), not a per-client tool attribute, so
  // a screen that doesn't explicitly compute and pass this must not show it by default.
  @Input() servicePlanHasAccess: boolean = false
  @Input() showBackButton: boolean = true
  @Input() showCancelDialog: boolean = false
  @Output() navigateBackClick = new EventEmitter<void>()

  _dashboardUrl: string
  _isHidden: boolean = false
  /**
   * Initializing Services
   */
  constructor(
    public router: Router,
    private commonService: CommonService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this._dashboardUrl = `client-dashboard/${this.clientId}`
    const maxScreenSize = window.matchMedia('(max-width: 892px)')
    if (maxScreenSize.matches) {
      this._isHidden = true
    } else {
      this._isHidden = false
    }
  }

  onNavigateBackClick(): void {
    // Emit the event to notify the parent component (wrapper component)
    this.navigateBackClick.emit()
  }

  redirect(destination: string) {
    this.router.navigate([destination])
  }

  navigateTo(target: string): void {
    if (this.showCancelDialog) {
      this.cancelAssessment(target)
    } else {
      this.commonService.navigateTo(target, this.clientId)
    }
  }

  cancelAssessment(target: string): void {
    const dialogRef = this.dialog.open(AreYouSureModalComponent, {
      width: '605px',
      height: '316px',
      panelClass: 'are-you-sure-panel',
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.commonService.navigateTo(target, this.clientId)
      } else {
      }
    })
  }

  toggleSubMenu(): void {
    const subMenu = document.getElementById('subMenu')
    if (subMenu) {
      if (this._isHidden === true) {
        subMenu.style.height = 'auto'
        this._isHidden = !this._isHidden
      } else {
        subMenu.style.height = '50px'
        this._isHidden = !this._isHidden
      }
    }
  }
}
